import { connect } from "react-redux";
import BenchmarkAnalysis from "./BenchmarkAnalysis";
import { handleChangeBenchmarkFilter } from "../../../../redux/actions";


const mapStateToProps = (state) => ({
    // Only the gate flag lives here — it flips at most once per fetch cycle, so
    // it won't re-render this PDF-capture host on every filter edit. The counts
    // the notice needs (survey count, leader-gate scope) are read inside
    // InsufficientSelectionNotice itself.
    isLeaderGateNotMet: state.BenchmarkFilteringReducer.isLeaderGateNotMet,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(BenchmarkAnalysis);
